<template>
  <div class="flex h-full w-full items-center justify-center p-6">
    <user-data-input-component @registered="$emit('registered')" />
  </div>
</template>

<script>
import userDataInputComponent from "../components/user-data-input.component.vue";
export default {
  components: { userDataInputComponent },
};
</script>

<style></style>
